import { Component, OnInit, Input, Inject, ViewChild } from '@angular/core';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from '../status/status-constant';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { LoaderService } from '../../shared/loader/loader.service';

@Component({
  selector: 'app-addEmailAction',
  templateUrl: './addEmailAction.component.html',
  styleUrls: ['./addEmailAction.component.scss'] 
})

export class AddEmailActionComponent implements OnInit {

  @Input() modulename: string;  
  @Input() entityID:number;
  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;

  myTouchesForm: FormGroup; 
  folderId:number=0;
  getTagListResponseHolder: any;
  formDialog: FormGroup;

  OfficeIDList: any=[];
  myOfficeID: any; 

  recipients:string="";
  emailTemplateList:any=[]=[];
  subject:string="";
  msg:string="";
  spinner:boolean=false; 
  public editorConfig = {
    versionCheck: false
  };
  ckEditorConfig: any = {
    toolbar: [
      ['Source', 'Templates', 'Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'CopyFormatting', 'RemoveFormat'],
      ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'],
      ['Find', 'Replace', '-', 'SelectAll', '-', 'Scayt'],
      ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'BidiLtr', 'BidiRtl'],
      ['Link', 'Unlink', 'Anchor'],
      ['Image', 'Table', 'HorizontalRule', 'Smiley', 'SpecialChar', 'PageBreak', 'Iframe'],
      ['Styles', 'Format', 'Font', 'FontSize'],
      ['TextColor', 'BGColor'],
      ['Maximize', 'ShowBlocks']
    ]
  };
  
  disabledEmailNotification:boolean=false;

  constructor(private dialog: MatDialog,private dialog1: MatDialog,private datePipe: DatePipe, public dialogRef: MatDialogRef<AddEmailActionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private formBuilder: FormBuilder, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private settingsService: SettingService, private statusConst: StatusConstant,
    private coreService: CoreService, private toastr: ToastrService,private loaderService: LoaderService, ) {  
     
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    if(encryptedtoken!=null){
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey,encryptedtoken);   
      this.currentUser = jwt_decode(token); 
      var offices=JSON.parse(sessionStorage.getItem('officeList'));
      offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID);
      if(oe.isMyoffice==true)
        this.myOfficeID=oe.officeID;
      });
    } 
    
  }  
  
  ngOnInit(): void {    
     
    this.getOfficeMailConfigration();
    this.getEmailTemplateList();      
  }
      
  // For Get All Template List
 getEmailTemplateList(){
  var ReqModel={
    emailTemplateID: 0,     
    userID: this.currentUser.UID,
    organizationID: Number(this.organizationId),
    officeID: Number(this.myOfficeID),
    officeIDList: this.OfficeIDList,
    databaseID: Number(this.databaseId)
  }  
   this.settingsService.getAllEmailTemplates(ReqModel).subscribe(response => {
   if (response != undefined) {
      this.responseHolder = response;    
      if (this.responseHolder.status == this.statusConst.statusSuccess) {           
          this.emailTemplateList=this.responseHolder.data;
       }else{      
       }
     }else{      
     }
   });
 }

 getDetails(emailTemplateID){
  var ReqModel={
    emailTemplateID: emailTemplateID,     
    userID: this.currentUser.UID,
    organizationID: Number(this.organizationId),
    officeID: Number(this.myOfficeID),
    officeIDList: this.OfficeIDList,
    databaseID: Number(this.databaseId)
   }
   //this.loaderService.show();
   this.settingsService.getEmailTemplateDetail(ReqModel).subscribe(response => {
   if (response != undefined) {
      this.responseHolder = response;
      //this.loaderService.hide();
      if (this.responseHolder.status == this.statusConst.statusSuccess) {          
        //this.templateName=this.responseHolder.data.emailTemplateName;
        this.msg=this.responseHolder.data.emailTemplateBody;
        this.subject=this.responseHolder.data.emailTemplateSubject;
       }else{
        //this.loaderService.hide();
       }
     }else{
      //this.loaderService.hide();
     }
   });
 }

 OnSelectTemplate($event) {     
  this.getDetails(Number($event.value)); 
 }
  
  
 async SaveEmailAction() {
    if(this.recipients==""){
      this.toastr.warning("Please add recipients.", '', {
        timeOut: 3000,
      }); 
      return;
    }
    var check = this.recipients;
    var newcheck:any=[];
    newcheck=check.split(',');
    for(var i = 0; i < newcheck.length; i++) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      var checkemail = re.test(String(newcheck[i]).toLowerCase());
      if (checkemail == true) {
      } else {
        this.toastr.warning('Please provide valid email.', '', {
          timeOut: 3000,
        });
        return;
      }
    }
    if(this.subject==""){
      this.toastr.warning("Please add subject.", '', {
        timeOut: 3000,
      }); 
      return;
    }
    if(this.msg==""){
      this.toastr.warning("Please add message.", '', {
        timeOut: 3000,
      }); 
      return;
    }
   // return;
    this.data;
    var modulename = this.data.moduleName;   
   
    if(modulename == "Core"){
     this.CoreSendActivityEMail();    
    }  
    if(modulename == "Contact"){
      this.ContactSendActivityEMail();
    }  
     if(modulename == "Company"){
      this.CompanySendActivityEMail();     
    } 
   
 }


  async CoreSendActivityEMail() {    
    //var message:any;
    //message=this.msg;
    var ReqModel={     
      toEmail:this.recipients,
      subject:this.subject,
      body: this.msg,
      cid:Number(sessionStorage.getItem('transactionID')),     
      organizationID:Number(this.organizationId),
      databaseID:Number(this.databaseId),
      userID:this.currentUser.UID,
      officeID:this.myOfficeID,
    }    
    this.spinner=true;    
    this.loaderService.show();
    const result = await this.coreService.SendActivityEMailCore(ReqModel).toPromise();
    if (result.status === this.statusConst.statusSuccess) {
       this.spinner=false; 
       this.loaderService.hide();
       this.dialogRef.close('Added');
       this.toastr.success("Email send successfully.", '', {
          timeOut: 3000,
       });      
     }else { 
      this.loaderService.hide();
      this.spinner=false;
      this.dialogRef.close('Error');
    } 
  }

  async ContactSendActivityEMail() {    
     //var message:any;
    //message=this.msg;
    var ReqModel={     
      toEmail:this.recipients,
      subject:this.subject,
      body: this.msg,
      cid:Number(sessionStorage.getItem('transactionID')),     
      organizationID:Number(this.organizationId),
      databaseID:Number(this.databaseId),
      userID:this.currentUser.UID,
      officeID:this.myOfficeID,
    }    
    this.spinner=true;
    this.loaderService.show();
    const result = await this.coreService.SendActivityEMailContact(ReqModel).toPromise();
    if (result.status === this.statusConst.statusSuccess) {
       this.spinner=false; 
       this.loaderService.hide();
       this.dialogRef.close('Added');
       this.toastr.success("Email send successfully.", '', {
          timeOut: 3000,
       });      
     }else { 
      this.loaderService.hide();
      this.spinner=false;
      this.dialogRef.close('Error');
    } 
  }
 
  async CompanySendActivityEMail() {    
    //var message:any;
    //message=this.msg;
    var ReqModel={     
      toEmail:this.recipients,
      subject:this.subject,
      body: this.msg,
      cid:Number(sessionStorage.getItem('transactionID')),     
      organizationID:Number(this.organizationId),
      databaseID:Number(this.databaseId),
      userID:this.currentUser.UID,
      officeID:this.myOfficeID,
    }    
    this.spinner=true;
    this.loaderService.show();
    const result = await this.coreService.SendActivityEMailCompany(ReqModel).toPromise();
    if (result.status === this.statusConst.statusSuccess) {
       this.spinner=false; 
       this.loaderService.hide();
       this.dialogRef.close('Added');
       this.toastr.success("Email send successfully.", '', {
          timeOut: 3000,
       });      
     }else { 
      this.loaderService.hide();
      this.spinner=false;     
      this.dialogRef.close('Error');
    } 
  }

  getOfficeMailConfigration() {
   var ReqModel = {     
     userID: this.currentUser.UID,
     organizationID: Number(this.organizationId),     
     officeID: this.myOfficeID
   };   
   this.settingsService.getOfficeMailConfigration(ReqModel).subscribe((response) => {
     if (response != undefined) {
       this.responseHolder = response;      
       if (this.responseHolder.status == this.statusConst.statusSuccess) { 
        if(this.responseHolder.data.eMailConfigeType==0){
          this.disabledEmailNotification=true;
        }else{
          this.disabledEmailNotification=false;
        }   
        // if(this.responseHolder.data.isCustomSMTP==true){
        //  if(this.responseHolder.data.smtpDetails!=null){
        //    this.disabledEmailNotification=false;
        //  }else{
        //    this.disabledEmailNotification=true;
        //   }
        // }else{
        //  this.disabledEmailNotification=true;
        // }
       }
     }else{
      
     }
   });
  }

  close() {   
    this.dialog.closeAll();
  }

}
